export const ANIMATION_UPDATE = "ANIMATION_UPDATE";
export const ANIMATION_CLEAR = "ANIMATION_CLEAR";
